import { render, staticRenderFns } from "./Presence.vue?vue&type=template&id=d38e4fdc&scoped=true&"
import script from "./Presence.vue?vue&type=script&lang=js&"
export * from "./Presence.vue?vue&type=script&lang=js&"
import style0 from "./Presence.vue?vue&type=style&index=0&id=d38e4fdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38e4fdc",
  null
  
)

component.options.__file = "Presence.vue"
export default component.exports